import React from "react";
import PropTypes from "prop-types";
import styles from "./BannerItem.module.css";

/**
 * View component. Displays a feed item’s banner.
 */
export function BannerItem({ bannerSrc, align }) {
  const backgroundPosition =
    align === "left"
      ? "left center"
      : align === "right"
      ? "right center"
      : "center center";

  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url(${bannerSrc})`,
        backgroundPosition,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        width: "100%",
        height: "60px",
      }}
    ></div>
  );
}

BannerItem.propTypes = {
  /**
   * Src of the banner image.
   */
  bannerSrc: PropTypes.string,
  /**
   * String that determines the alignment of the banner src image.
   */
  align: PropTypes.oneOf(["left", "center", "right"]),
};
